var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextBulletList = function SvgTextBulletList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71717A",
    d: "M2.5 5a.833.833 0 1 1 1.667 0A.833.833 0 0 1 2.5 5ZM2.5 10a.833.833 0 1 1 1.667 0A.833.833 0 0 1 2.5 10ZM2.5 15a.833.833 0 1 1 1.667 0A.833.833 0 0 1 2.5 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M17.5 5h-10m10 5h-10m10 5h-10M3.333 5.834a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextBulletList);
export default ForwardRef;